/**
 * Configures per-route overrides of the home background, used by
 * `src/routes/HomeBackground.svelte` (new layout only).
 *
 * Any route whose path starts with `routePrefix` gets its background replaced by `color`
 * (behind the page content, transitioning smoothly - see `.home-background-route-override`
 * in HomeBackground.svelte) instead of the home's own photo/color/gradient background.
 *
 * Add more entries here to cover additional routes - no other code changes needed.
 */
export interface RouteBackgroundOverride {
	routePrefix: string;
	color: string;
}

export const ROUTE_BACKGROUND_OVERRIDES: RouteBackgroundOverride[] = [
	{ routePrefix: '/settings', color: '#000000' },
];

/** Returns the override color for the given `$location`, or `undefined` if none applies. */
export function getRouteBackgroundOverrideColor(location: string): string | undefined {
	return ROUTE_BACKGROUND_OVERRIDES.find((override) => location?.startsWith(override.routePrefix))
		?.color;
}
